export const FROZEN_HEADER_FLIGHT = "<strong>Flight</strong> | Departs on ";
export const FROZEN_HEADER_HOTEL = "<strong>Hotel</strong> | Check-in on ";
